import {AvantButton} from "../../../generic-components/AvantButton";
import * as React from "react";
import {LoginDTO} from "../../../../types/types";
import {isSecureURLForWebAndLocal} from "../../../../util/UrlUtil";

/** Email reminders should be shown only for a login for which there is an attached proctored exam.
 *  Coincidentally, this is the same criteria used to show the `SchedulingLink`.
 */
export function showEmailReminders(login: LoginDTO): boolean {
    return login.anyProctorScheduleIsAttached === true && isSecureURLForWebAndLocal(login.schedulingLink ?? "")
}

/**
 * Triggers an `EmailRemindersDialog` which allows a teacher to email reminders to selected test takers.
 *
 * The reminder email is automated, and based on the status of that test taker.
 * The test taker may be reminded to schedule an exam (if they haven't already) or about the time of their exam (if they have scheduled).
 *
 * TODO: A teacher can set non-email unique ids for rostered test instances.
 * There is no indication in `EmailReminders` that this will fail to reach the test taker.
 */
export function EmailReminders({login, handleEmailReminders}: { login: LoginDTO, handleEmailReminders: (l: LoginDTO | undefined) => void}) {
    return (
        <AvantButton
            onClick={() => handleEmailReminders(login)}
        >
            Email Reminders
        </AvantButton>
    )
}